import React, { useMemo } from 'react';
import FormattedText from './FormattedText';
const allowed = new Set([
  'p',
  'div',
  'span',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  's',
  'ul',
  'ol',
  'li',
  'blockquote',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'table',
  'thead',
  'tbody',
  'tr',
  'th',
  'td',
  'a',
]);
const dropped = new Set(['script', 'style', 'iframe', 'object', 'embed', 'form', 'input', 'svg']);
export default function RichTextPreview({ html }) {
  const nodes = useMemo(() => {
    if (!html) return null;
    if (typeof DOMParser === 'undefined')
      return <FormattedText>{String(html).replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ')}</FormattedText>;
    const document = new DOMParser().parseFromString(html, 'text/html');
    function render(node, key) {
      if (node.nodeType === 3) return <FormattedText key={key}>{node.textContent}</FormattedText>;
      if (node.nodeType !== 1) return null;
      const tag = node.tagName.toLowerCase();
      if (dropped.has(tag)) return null;
      const children = Array.from(node.childNodes).map((child, index) =>
        render(child, `${key}-${index}`)
      );
      if (!allowed.has(tag)) return children;
      const props = { key };
      if (tag === 'a') {
        try {
          const url = new URL(node.getAttribute('href'), window.location.origin);
          if (['http:', 'https:'].includes(url.protocol)) props.href = url.href;
        } catch (error) {
          /* Keep unsafe links as text. */
        }
        props.target = '_blank';
        props.rel = 'noopener noreferrer';
      }
      if (['th', 'td'].includes(tag))
        ['colspan', 'rowspan'].forEach((attribute) => {
          const value = Number(node.getAttribute(attribute));
          if (value > 0 && value < 100)
            props[attribute === 'colspan' ? 'colSpan' : 'rowSpan'] = value;
        });
      return React.createElement(tag, props, ...(tag === 'br' ? [] : children));
    }
    return Array.from(document.body.childNodes).map((node, index) => render(node, String(index)));
  }, [html]);
  return <div className="portal-rich-preview">{nodes}</div>;
}
